import React, { Component } from 'react';
import { connect } from 'react-redux';
import { errorActions, fetchMyAuthors, selecteAuthor, applyAuthor,applyAuthorGroup } from '../../actions';
import { Nav, NavItem, NavLink, TabContent, TabPane, Form, FormGroup, Input, Modal, Alert, Label} from 'reactstrap';
import myFetchWithId from '../../helpers/myFetch';
import { withRouter } from 'react-router-dom';
import Loader from 'react-loader-advanced';
import { CreateItem, UpdateItem, DeleteItem } from '../../helpers/crud';

const mapStateToProps = (state) => {
	return {
		myAuthorGroups: state.search.savedAuthors,
		selectedAuthor: state.search.selectedAuthor
	};
};

const mapDispatchToProps = dispatch => {
	return {
		fetchMyAuthors: () => dispatch(fetchMyAuthors()),
		selecteAuthor: (index, array) => dispatch(selecteAuthor(index, array)),
		applyAuthor: (block, author) => dispatch(applyAuthor(block, author)),
		updateError: (err) => dispatch(errorActions.update(err)),
		applyAuthorGroup:(block, author) => dispatch(applyAuthorGroup(block, author)),
	};
};
const keywordApi = '/v5/lowi/profile/sa';
const spinner = <div className="lds-ripple"><div></div><div></div></div>;

class MyAuthorComponent extends Component {
  constructor(props) {
    super(props);
    this.apply = this.apply.bind(this);
	this.select = this.select.bind(this);
    this.cancel = this.cancel.bind(this);
	this.setType = this.setType.bind(this);
	this.toggleEmptyAlert = this.toggleEmptyAlert.bind(this);

    this.state = {
		emptyAlert: false,
		currId: '',
		currName: '',
		currAuthors: false,
		currAuthorGroup:[],
		loading: false,
		filterType: 1,
		currAuthorGroupTindex: 0
    }
  }


	// READE: select and get the author list from the group
	select(id, tIndex) {
		const normalFetch = myFetchWithId('', true, true);
		this.setState({loading: true});
		try {
			normalFetch(`${keywordApi}/get`, {id: id})
			.then( data => {
				this.props.selecteAuthor(tIndex, this.props.selectedAuthor);
				if (data.response_data) {
					const decodeName = decodeURIComponent(data.response_data[0].name)
					if (data.response_data[0].authors) {
						// const savedAuthors = data.response_data[0].authors;
						// const authors = [];
						// for(const prop in savedAuthors) {
						// 	authors.push({id: prop, name: decodeURIComponent(savedAuthors[prop])});
						// }
						 const authors = data.response_data[0].authors.map( obj => ({
							 id: obj.id,
							 name: decodeURIComponent(obj.author)
						 }))
						this.setState({
							currId: data.response_data[0].id,
							currName: decodeName,
							currAuthors: authors,
							loading: false,
							currAuthorGroupTindex: tIndex
						});
					} else {
						this.setState({
							currId: data.response_data[0].id,
							currName: decodeName,
							currAuthors: [],
							loading: false,
							currAuthorGroupTindex: tIndex
						})
					}
				} else {
					this.setState({
						currAuthors: [],
						loading: false,
						currAuthorGroupTindex: tIndex
					});
				}
			})
		} catch (err) {
				this.props.updateError(err);
				this.setState({loading: false})
		}
	}


	// ACTION WITH SEARCH

	apply() {
		const block = this.state.filterType===1 ? false : true;
		const authorArray = this.state.currAuthors;
		const authorGroup = [this.props.myAuthorGroups[this.state.currAuthorGroupTindex]]
		if (authorArray===false || authorArray.length ===0) {
			this.setState({emptyAlert: true});
		} else {
			for (let i = 0; i < authorArray.length; i++) {
				// applyAuthor 需要包一個檢查不重複的funciotn
				this.props.applyAuthor(block, authorArray[i].name);
			}
			this.props.closeModal();
		}

		// console.log(authorGroup)
		// if(authorGroup[0].authors.length === 0){
		// 	this.setState({emptyAlert: true});
		// }else{
		// 	this.props.applyAuthorGroup(block, authorGroup);
		// 	this.props.closeModal();
		// }
	}

	setType(type) {
		this.setState({ filterType: type });
	}
	toggleEmptyAlert() {
		this.setState(prevState => ({emptyAlert: !prevState.emptyAlert}));
	}
	cancel() {
		this.props.closeModal();
	}

	// COMPONENT LIFE CURCLE
	componentDidMount() {
		this.props.fetchMyAuthors();
	}
  render() {
    return (
      <div className='ad-search-popup'>

        <div className="popup-modal-header">
          <h3>我的作者</h3>
        </div>

				<div className="popup-modal-content">
					<div className='author-controller'>

						<CreateItem
							apiCall={`${keywordApi}/create`}
							fetchItem={this.props.fetchMyAuthors}
							updateError={this.props.updateError}
							contentText={'請設定此作者名單的名稱'}
						>
							{({toggleNameSet}) => (
								<button className='add-list' onClick={toggleNameSet}>建立作者名單</button>
							)}
						</CreateItem>

						<div className='popup-modal-filter-author'>
							<FormGroup check>
								<Label check>
									<Input type="radio" name="radio1" checked={this.state.filterType===1 ? true : false} onChange={() => {this.setType(1)}}/>
									僅搜尋所選擇的作者名單
								</Label>
							</FormGroup>
							<FormGroup check>
								<Label check>
									<Input type="radio" name="radio2" checked={this.state.filterType===2 ? true : false} onChange={() => {this.setType(2)}}/>
									排除所選擇的作者名單
								</Label>
							</FormGroup>
						</div>

					</div>

					<div className='my-search popup-filter'>
						<div className='my-search-sidebar max-heigh-sidebar'>
							{this.props.myAuthorGroups.length > 0 ?
								<ul>
									{this.props.myAuthorGroups.map( (obj, index) =>
										<li className={`my-media-title title-selected-${this.props.selectedAuthor[index]}`} key={index}>
											<a onClick={() => this.select(obj.id, index)}>
												{decodeURIComponent(obj.name)}
											</a>
											<div>
												<UpdateItem
													apiCall={`${keywordApi}/update`}
													fetchItem={this.props.fetchMyAuthors}
													updateError={this.props.updateError}
													contentText={'重新命名此作者組合的名稱'}
												>
													{({toggleRename}) => (
														<i className='icon-pencil icons lowi-icon widget-tip' onClick={() => toggleRename(obj.id, obj.name)}>
															<span className="widget-tiptext">重新命名</span>
														</i>
													)}
												</UpdateItem>
												<DeleteItem
													apiCall={`${keywordApi}/delete`}
													fetchItem={this.props.fetchMyAuthors}
													updateError={this.props.updateError}
													setInit={()=> this.setState({currAuthors: false})}
												>
													{({toggleDelete}) => (
														<i className='icon-trash icons lowi-icon widget-tip' onClick={() => toggleDelete(obj.id, obj.name)}>
															<span className="widget-tiptext">刪除</span>
														</i>
													)}
												</DeleteItem>
											</div>
										 </li>
										)}
									</ul> :
									<div>您尚未建立任何作者名單</div>
								}
							</div>

							<div className='set search-result'>
								<Loader show={this.state.loading} message={spinner} hideContentOnLoad={true}>
									{Array.isArray(this.state.currAuthors) ?
										this.state.currAuthors.length > 0 ?
											<div className='filter-container max-heigh-container'>
												{this.state.currAuthors.map((author, index) =>
													<div className='filter__badge neutral' key={index}>
														{author.name}
														<DeleteItem
															apiCall={`${keywordApi}/removeauthor`}
															fetchItem={() => this.select(this.state.currId, this.state.currAuthorGroupTindex)}
															updateError={this.props.updateError}
															setInit={()=> {}}
														>
															{({toggleDelete}) => (
																<i className='fa fa-close lowi-icon' onClick={() => toggleDelete(author.id, author.name)}></i>
															)}
														</DeleteItem>
													</div>
												)}
											</div>

											: <div>此作者名單是空的</div>
										: null
									}
								</Loader>
							</div>
						</div>

					<div className="popup-modal-buttonset">
						<button className="cancel" onClick={this.cancel}>
							取消
						</button>
						<button className="apply" onClick={this.apply}>
							套用至搜尋條件
						</button>
					</div>
				</div>
				<Modal size='sm' isOpen={this.state.emptyAlert} toggle={this.toggleEmptyAlert}>
					<div className="popup-modal">
						<div className="popup-modal-content">
							您未選擇任何作者
							<div className="popup-modal-buttonset">
								<button className="apply" onClick={this.toggleEmptyAlert}>
									確定
								</button>
							</div>
						</div>
					</div>
				</Modal>
      </div>
    );
  }
}

const MyAuthor = connect(mapStateToProps, mapDispatchToProps)(MyAuthorComponent);

export default withRouter(MyAuthor);



// WEBPACK FOOTER //
// ./src/components/popup/myAuthor.js